<template>
  <div>
    <router-link
      active-class="active"
      tag="div"
      class="staff-item d-flex px-3 py-3"
      v-for="staff in staffs"
      :key="staff.adminId"
      :to="{ name: 'StaffEdit', params: { adminId: staff.adminId } }"
    >
      <div class="flex-grow-1 flex-shrink-0">
        <div class="staff-meta mb-1">
          <strong>{{ staff.firstName + " " + staff.lastName }}</strong>
        </div>
        <div class="staff-role">
          ตำแหน่ง <strong>{{ (staff.adminRole || {}).roleCode }}</strong>
        </div>
      </div>
    </router-link>
  </div>
</template>

<script>
export default {
  props: {
    staffs: {
      type: Array
    }
  }
};
</script>

<style lang="scss" scoped>
.staff-item {
  font-size: 16px;
  cursor: pointer;
  border-bottom: 1px solid #f5f5f5;

  &:hover {
    background: #f9f9f9;
  }
  &.active {
    background: #efefef;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/admin/view/staff/StaffNavigation.vue